import React from 'react'
import Popup from 'src/components/Popup/Popup'
import { css } from 'styled-components'

import APIKeyCreatedForm from './APIKeyCreatedForm'

interface APIKeyCreatedFormProps {
  closeAPIKeyCreatedForm: () => void
}
const APIKeyCreatedPopup: React.FC<APIKeyCreatedFormProps> = (props) => {
  return (
    <Popup
      css={css`
        z-index: 10;
        display: flex;
        flex-direction: column;
        position: relative;
        box-shadow: none;
      `}
      onClose={props.closeAPIKeyCreatedForm}
    >
      <APIKeyCreatedForm
        closeAPIKeyCreatedForm={props.closeAPIKeyCreatedForm}
      />
    </Popup>
  )
}

export default APIKeyCreatedPopup
